const APP_ENTRIES = {
    BADGES: 'badges',
    REWARDS: 'rewards',
} as const;

export type AppEntry = (typeof APP_ENTRIES)[keyof typeof APP_ENTRIES];

export default APP_ENTRIES;
